import styled from '@emotion/styled'
import { Box, IconButton, Typography } from '@material-ui/core'

const Form = styled('form')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
}))

const GreetingTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  fontWeight: theme.typography.fontWeightBold,
}))

const InputCardAnchor = styled('div')({
  width: '100%',
  display: 'flex',
})

const InputCard = styled(Box, {
  shouldForwardProp: (prop) => prop !== '$focused'
})<{ $focused: boolean }>(({ theme, $focused }) => ({
  width: '100%',
  border: `1px solid ${$focused ? theme.palette.primary.main : theme.palette.border.light}`,
  borderRadius: theme.palette.border.borderRadius,
  backgroundColor: theme.palette.background.paper,
  transition: 'border-color 0.2s ease',
  padding: theme.spacing(1.5, 1.5, 1, 2),
  display: 'flex',
  flexDirection: 'column',
}))

const InputRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(2)
}))

const HiddenFileInput = styled('input')(() => ({
  display: 'none',
}))

const SendButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: '#fff',
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
    filter: 'brightness(0.9)',
  },
  '&.Mui-disabled': {
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    opacity: 0.5,
  },
}))

export {
  Form,
  GreetingTitle,
  InputCardAnchor,
  InputCard,
  InputRow,
  HiddenFileInput,
  SendButton,
}
